import iconChecked from 'assets/icons/check-preenchido.svg'
import { useAccessibility } from 'context/hooks/useAccessibility'
import { type InconsistenciesType } from 'types/services/Inconsistencies'
import { BreadcrumbCustom, CardReliability, TitlePage } from '..'

import './styles.scss'
interface HeaderSectionsProps {
  links: any
  title: string
  inconsistencies: InconsistenciesType | undefined | null
}
function HeaderSections({
  links,
  title,
  inconsistencies,
}: HeaderSectionsProps) {
  const { contrastIsSelected } = useAccessibility()

  return (
    <header className="containerHeaderSections">
      <div className="containerHeaderSections-title">
        <BreadcrumbCustom routes={links} />
        <TitlePage style={{ margin: '0' }} title={title} />
        <ul className="cards-types">
          <li>
            <img
              className="icon"
              id="condicao-estavel"
              src={iconChecked}
              alt="ok"
              height="20px"
              style={{ marginRight: '1rem' }}
            />
            <label htmlFor="#condicao-estavel">Condição estável</label>
          </li>
          <li>
            <div
              className="icon"
              id="alert-condition"
              style={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                color: 'white',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'var(--red-primary)',
                marginRight: '1rem',
                fontFamily: 'IBM Plex Sans, sans-serif',
                fontWeight: '800',
              }}
            >
              !
            </div>
            <label htmlFor="#alert-condition">Condição de alerta</label>
          </li>
          <li>
            <div
              className="icon"
              id="inconsistent"
              style={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                color: 'white',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'var(--yellow-secondary)',
                marginRight: '1rem',
                fontFamily: 'IBM Plex Sans, sans-serif',
                fontWeight: '800',
              }}
            >
              ?
            </div>
            <label htmlFor="#inconsistent">
              Informação inconsistente entre as bases
            </label>
          </li>
        </ul>
      </div>
      <div className="containerHeaderSections-card">
        <CardReliability
          indicative={
            inconsistencies != null && inconsistencies !== undefined
              ? 100 - inconsistencies.inconsistencyPercentual
              : inconsistencies
          }
          isHighContrastAndDefaultColors={contrastIsSelected}
        />
      </div>
    </header>
  )
}

export default HeaderSections
